<div *ngIf="uploading" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div class="alert alert-warning" *ngIf="uploadFailed">Upload failed, please contact support
</div>

<div class="alert alert-warning" *ngIf="filename && !zipFile">Only ZIP files are supported
</div>

<h1 class="table__title">Upload Zip File</h1>

<ul class="table__control inline-list">
  <li>
    <button mat-raised-button (click)="onNoClick()" color="accent">Close</button>
  </li>
  <li>
    <button mat-raised-button (click)="upload()" [disabled]="!zipFile" color="primary">Upload</button>
  </li>
  <li>
    <button mat-raised-button (click)="selector.click()" color="primary">Select File</button>
  </li>
</ul>

<h2>Uploading: {{filename}}</h2>

<input style="display:none" #selector class="fileSelector" #fileSelector type="file" ng2FileSelect
  [uploader]="uploader" />
